import { render, staticRenderFns } from "./DPadX1.vue?vue&type=template&id=38c7eae1"
import script from "./DPadX1.vue?vue&type=script&lang=js"
export * from "./DPadX1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports